import React from 'react';
import DOMPurify from 'dompurify';
import PhoneNumber from '../../../../../components/PhoneNumber/PhoneNumber';

const PHONE_REGEX =
  /(?<!\d)(?:\+7|8|7)?[\s-]?\(?\d{3}\)?[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2}(?!\d)/g;

const ALLOWED_ATTRIBUTES = ['href', 'target', 'rel', 'title'];

const toStyleObject = (css) =>
  css.split(';').reduce((styles, declaration) => {
    const [property, ...valueParts] = declaration.split(':');
    const value = valueParts.join(':').trim();

    if (!property.trim() || !value) return styles;

    const key = property
      .trim()
      .replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());

    return { ...styles, [key]: value };
  }, {});

const buildProps = (node, key) => {
  const props = { key };

  Array.from(node.attributes).forEach(({ name, value }) => {
    if (name === 'style') {
      props.style = toStyleObject(value);
    } else if (name === 'class') {
      props.className = value;
    } else if (ALLOWED_ATTRIBUTES.includes(name)) {
      props[name] = value;
    }
  });

  return props;
};

const formatInfo = (info) =>
  info
    .trim()
    .replace(/^(?:\n|\n)/, '')
    .replace(/(?:\n|\n)/g, '<br />');

const splitTextByPhones = (text, key) => {
  const parts = [];
  const regex = new RegExp(PHONE_REGEX.source, 'g');
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }

    parts.push(
      <PhoneNumber
        key={`${key}-phone-${match.index}`}
        phoneNumber={match[0].replace(/\D/g, '')}
      />
    );

    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }

  return parts;
};

const domToReact = (node, key) => {
  if (node.nodeType === Node.TEXT_NODE) {
    return splitTextByPhones(node.textContent, key);
  }

  if (node.nodeType !== Node.ELEMENT_NODE) {
    return [];
  }

  const props = buildProps(node, key);

  const children = Array.from(node.childNodes).flatMap((child, index) =>
    domToReact(child, `${key}-${index}`)
  );

  return [React.createElement(node.tagName.toLowerCase(), props, ...children)];
};

export const HintText = ({ info, withPhoneLinks = false }) => {
  const html = DOMPurify.sanitize(formatInfo(info));

  if (!withPhoneLinks) {
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  }

  const doc = new DOMParser().parseFromString(
    `<body>${html}</body>`,
    'text/html'
  );

  return (
    <div>
      {Array.from(doc.body.childNodes).flatMap((node, index) =>
        domToReact(node, `hint-${index}`)
      )}
    </div>
  );
};
